import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css"
import React from "react";
import NavBar from "./NavBar";

import 'bootstrap/dist/css/bootstrap.min.css'

const isDev = window.location.hostname.includes('.dev.')
const isLocalhost = window.location.hostname.includes('localhost')

function App() {
  const queryParams = getQueryParams()
  const token = localStorage.getItem('token') || ''
  const [context, setContext] = React.useState(queryParams.context || '')

  initAuth(queryParams, token)

  return (
      <div>
        <NavBar context={context} setContext={setContext}/>

        {
          isContextValid(context) ?
              // @ts-ignore
              <SwaggerUI url={getUrlFromContext(context)}
                         requestInterceptor={getRequestInterceptor(token)}
                         responseInterceptor={getResponseInterceptor()}
                         docExpansion="none"
              /> :
              <div>
                <h3>Please, select an Api to show docs.</h3>
              </div>
        }

      </div>
  );
}

function getUrlFromContext(context: string) {
  if(isLocalhost) {
    let domain;
    switch (context) {
      case 'auth/v1':
        domain = "localhost:8000"
        break;
      case 'devices/v1':
        domain = "localhost:8001"
        break;
      case 'payments/v1':
        domain = "localhost:8002"
        break;
      case 'reports/v2':
        domain = "localhost:8003/v2"
        break;
    }
    
    return `http://${domain}/v3/api-docs`
  }

  const devStr = (isDev || isLocalhost) ? '.dev' : ''

  return `https://api${devStr}.foodytek.com/${context}/v3/api-docs`
}
function isContextValid(context: string): boolean {
  const valid = ['auth/v1', 'devices/v1', 'payments/v1', 'reports/v2']
  return valid.includes(context)
}

function getRequestInterceptor(token: string): (req: any) => any {
  return (req: any): any => {
    req.headers.Authorization = 'Bearer ' + token
    return req
  }
}

function getResponseInterceptor(): (req: any) => any {
  return (res: Response): Response => {
    if (res.status === 401) redirectToLogin()
    if( res.status === 403) {
      alert("You must be an admin to access this API")
      redirectToLogin()
    }
    if (res.status !== 200) console.log(res)
    return res
  }
}



function initAuth(queryParams: any, token: string) {
  if (token && !queryParams.token) return;

  if (queryParams.token) {
    localStorage.setItem('token', queryParams.token)
    // @ts-ignore
    window.location = window.location.origin
    return;
  }

  redirectToLogin()
}

function redirectToLogin() {
  localStorage.removeItem('token')

  let redirectTo = window.location.hostname === 'localhost'
      ? 'http://localhost:8080'
      : `https://login${isDev ? '.dev' : ''}.foodytek.com`

  redirectTo += '/logout?to=' + encodeURIComponent(window.location.origin + '/')

  // @ts-ignore
  window.location = redirectTo
}

function getQueryParams() {
  let urlSearchParams = new URLSearchParams(window.location.search);
  return Object.fromEntries(urlSearchParams.entries());
}

export default App;
